
import s from './Pasadia.module.css';
import Landscape from '../../assets/Biodiversity/Landscape.jpg';
import pasadia1 from '../../assets/Pasadia1.jpg';
import pasadia2 from '../../assets/Pasadia2.jpg';
import pasadia3 from '../../assets/Pasadia3.jpg';

const Pasadia = () => {
  

  const backgroundImageStyle = {
    backgroundImage: `url(${Landscape})`,
  };

  return (
    <div className={s.bio}>
        
        <div className={s.bioContainer} style={backgroundImageStyle}>
            <div className={s.libro}>
                <img src={pasadia1} alt="" className={s.bioimg} />
                <img src={pasadia2} alt="" className={s.bioimg} />
                <img src={pasadia3} alt="" className={s.bioimg} />
            </div>
        </div>
    </div>
  );
};

  
    

export default Pasadia